import React from "react";
import HeroSection from "../components/personas/personasInicio/banner";
import CarouselCards from "../components/cards";
import SimuladorPersonas from "../components/personas/personasInicio/hero2";
import SecondaryBanner from "../components/SecondaryBanner";


function Personas() {
  return (
    <div className="flex flex-col items-center bg-gray-200 overflow-x-hidden">
      <HeroSection />
      <CarouselCards bgColor="#0047ab" textColor="#0047ab" />
      <SimuladorPersonas />
      <SecondaryBanner />
    </div>
  );
}

export default Personas;
